import Vue from 'vue/dist/vue.js';
import { sync, readMeta, newObject, fixLanguageLink, adapativFi } from '@src/js/darkrogua.drimond.js';
import noUiSlider from "nouislider";

window.Services = null;
if ($('._Filter').length) {
    Services = new Vue({
        el: '._Filter',
        delimiters: ['${', '}'],
        data: {
            services: false,
            category: '',
            query_url: '',
            locale: '',
            page: 1,
            site_id: 1,
            filters: {
                categories: '',
                price_from: '',
                price_to: '',
                query: '',
            },
            settings: {
                price_from: 0,
                price_to: 200,
                order_by: 'sort_order:asc',
            },
            categories: null,
            show: true,
        },
 
        mounted: function () {
            this.loadFilters();
            this.query_url = window.location.pathname.replace(/^\/..(\/|$)/, '/');
            this.locale = $('html').attr('lang');
            this.site_id = $('meta[name="site_id"]').attr('content');
            if ($(window).width() <= 992) this.show = false;
            eventCarouselMore();
        },

        methods: {
            loadFilters: function (callback) {
                this.services = readMeta('services');
                if (!callback) this.initPriceSlider();

                if (this.services) {
                    var $this = this;
                    sync(this, {
                        method: 'Filter@mounted',
                        data: {
                            locale: $('html').attr('lang'),
                            categories: $this.categories,
                        },
                        success: function (data) {
                            $this.categories = data.categories;
                            if (callback) callback();
                            $this.filters.query = $('meta[name="query"]').attr('content');
                            $('.resultSearch-sorting').html(data.active_filters);
                        }
                    });
                }
            },
            filterActiveParam: function () {
                this.filters.categories = newObject(this.categories);
                for (var item in this.filters.categories) {
                    for (var i in this.filters.categories[item]) {
                        for (var j in this.filters.categories[item][i]) {
                            if (j == 'options') {
                                var options = [];
                                for (var k in this.filters.categories[item][i][j]) {
                                    if (this.filters.categories[item][i][j][k]['check'] == false) {
                                        delete this.filters.categories[item][i][j][k];
                                        options = this.filters.categories[item][i][j].filter((_, index) => this.filters.categories[item][i][j].hasOwnProperty(index))
                                    }
                                }
                                this.filters.categories[item][i][j] = options;
                            }
                        }
                    }
                }
                delete this.filters.categories['tours']['link'];
                delete this.filters.categories['tickets']['link'];
                delete this.filters.categories['transfers'];
            },

            getItems: function (page) {
                this.show = false;
                if (page) this.page = page;
                this.filterActiveParam();
                this.category = readMeta('category');
               
                sync(this, {
                    before: function () {
                        $('#resultSearchItems').css('opacity', '0.5');
                        $('.preloader-drimond').toggleClass('active');
                    },
                    method: 'Filter@getItems',
                    data: {
                        page: this.page,
                        order_by: this.settings.order_by,
                        filters: this.filters,
                        category: this.category,
                        query_url: this.query_url,
                        locale: this.locale,
                        site_id: this.site_id
                    },
                    success: function (data) {
                        $('.resultSearch-leftPart.active').removeClass('active');
                        $('.sortList.active').removeClass('active');
                        $('#resultSearchItems').css('opacity', '1');
                        $('.preloader-drimond').toggleClass('active');
                        $('.resultSearch-sorting').html(data.active_filters);
                        $('#resultSearchItems').html(data.items_html);
                        adapativFi(this.category);
                        eventCarouselMore(this.category);

                        Services.scrollTop();
                        fixLanguageLink();
                    }
                });
            },

            cleanFilters: function (options, param) {
                if (options != undefined) {
                    if (options == 'price') {
                        document.getElementById('filterPrice').noUiSlider.set([this.settings.price_from, this.settings.price_to]);
                        this.filters['price_from'] = '';
                        this.filters['price_to'] = '';
                    } else if (param != undefined && param != '') {
                        for (var i in this.categories[options][param]['options']) {
                            this.categories[options][param]['options'][i]['check'] = null;
                        }
                        console.log('test0');
                    } else if (options == 'query') {
                        this.filters[options] = '';
                        $('meta[name="query"]').attr('content', '');
                        removeAllGetUrl('query');
                    } else {
                        this.filters[options] = '';
                    }
                } else {
                  
                    this.filters['categories'] = '';
                    document.getElementById('filterPrice').noUiSlider.set([this.settings.price_from, this.settings.price_to]);
                    this.filters['price_from'] = '';
                    this.filters['price_to'] = '';
                    this.filters['query'] = '';
                    this.categories = '';             
                }

                var $this = this;
                this.page = 1;
                this.loadFilters(function () {
                    $this.getItems();
                });
            },

            initPriceSlider: function () {
                var $this = this;
                var prices_slider = document.getElementById('filterPrice');

                noUiSlider.create(prices_slider, {
                    start: [$this.settings.price_from, $this.settings.price_to],
                    step: 10,
                    format: {
                        to: function (value) {
                            return value;
                        },
                        from: function (value) {
                            return Number(value.replace(',-', ''));
                        }
                    },
                    connect: true,
                    range: {
                        min: $this.settings.price_from,
                        max: $this.settings.price_to,
                    },
                    cssPrefix: 'noUi-',
                });
                prices_slider.noUiSlider.on('update', function (value, handle) {
                    $this.filters.price_from = value[0];
                    $this.filters.price_to = value[1];
                });

            },

            search: function (val) {
                this.filters.query = val;
                this.getItems();
            },

            createLangLink: function (link) {

                if (this.locale != 'en') {
                    link = '/' + this.locale + link;
                }
                return link;
            },

            showMore: function (category, page) {
                var width_display = $(window).width();
                sync(this, {
                    before: function () {
                        if (width_display > 992) {
                            $('#resultCategory-' + category).css('opacity', '0.5');
                            $('.preloader-drimond').toggleClass('active');
                        }
                    },
                    method: 'Filter@getItems',
                    data: {
                        page: page,
                        order_by: this.settings.order_by,
                        filters: this.filters,
                        category: category,
                        query_url: this.query_url,
                        width: width_display,
                        locale: this.locale,
                        site_id: this.site_id
                    },
                    success: function (data) {
                        if (width_display > 992) {
                            $('#resultCategory-' + category).css('opacity', '1');
                            $('.preloader-drimond').toggleClass('active');
                            $('#resultCategory-' + category + ' .tilesItemsCarousel').append(data.items_html);
                        } else {
                            data.items_html.forEach(function (element) {
                                $('#resultCategory-' + category + ' .tilesItemsCarousel').trigger('add.owl.carousel', element);
                            });
                            $('#resultCategory-' + category + ' .tilesItemsCarousel').trigger('refresh.owl.carousel');
                        }
                        $('#resultCategory-' + category + ' .wrapper-showMore').html(data.button_html);
                        fixLanguageLink();
                    }
                });
            },
            showFilter: function () {
                $('.resultSearch-leftPart').toggleClass('active');
            },
            showSort: function () {
                $('.sortList').toggleClass('active');
            },
            setActiveSort: function (i) {
                $('.sortList.active a').children('i').attr('class', 'fa fa-circle-o');
                $('.sortList.active a:eq(' + i + ')').children('i').attr('class', 'fa fa-circle');
            },
            scrollTop: function () {
                var pos = $('#resultSearchItems').offset().top;
                $('body, html').animate({scrollTop: pos - 150}, 500);
            },

        }
    });

    /*AJAX pagination*/
    $(document).on('click', 'ul.pagination a', function (e) {
        e.preventDefault();
        var href = $(this).attr('href');
        var page = /page(\d+)$/.exec(href)[1];
        Services.getItems(page);
        window.history.pushState(null, null, href);
    });


// $('.filter-button').on('click', function() {
//     Catalog.show = !Catalog.show;
// });


    $('.filter-category').on('click', function () {
        $(this).toggleClass('open');
        if ($(this).hasClass('open')) {
            $(this).find('.filter-catName i').removeClass('fa-angle-down');
            $(this).find('.filter-catName i').addClass('fa-angle-up');
        } else {
            $(this).find('.filter-catName i').removeClass('fa-angle-up');
            $(this).find('.filter-catName i').addClass('fa-angle-down');
        }
    });


// Слайдер цены


// Кастоманая выпадашка - сортировка
    $('.selectpickerCustom').selectpicker({
        style: 'btn-info',
        width: 'auto',
        size: 4
    });

// Смена адреса страницы без презагрузки

    function removeAllGetUrl(curLoc){
        try {
            let baseUrl = window.location.href.split("?")[0];
            history.pushState(null, null, baseUrl);
            return;
        } catch(e) {}
        //location.hash = '#' + curLoc;
    }

// Эмитируем нажатие кнопки показать еще при пролистывании карусели!
    function eventCarouselMore(category) {
        if (category) {
            $('#resultCategory-' + category + '.tilesItemsCarousel').on('next.owl.carousel drag.owl.carousel', function () {
                if ($(this).closest('.wrapper-itemsList').find('.resultSearch-showMore a')) {
                    $(this).closest('.wrapper-itemsList').find('.resultSearch-showMore a').click();
                }
            });
        } else {
            $('.tilesItemsCarousel').on('next.owl.carousel drag.owl.carousel', function () {
                if ($(this).closest('.wrapper-itemsList').find('.resultSearch-showMore a')) {
                    $(this).closest('.wrapper-itemsList').find('.resultSearch-showMore a').click();
                }
            });
        }


    }
}
export default {Services}
